import React, { memo, Fragment, useMemo, useEffect } from 'react';
import { createUseStyles } from '@Sage/hoi-poi-ui';

import SectionList from 'components/SectionList';
import ModalConfirm from 'components/ModalConfirm';
import MatchingModal from '../MatchingModal';
import CreateFieldModal from '../CreateFieldModal';

import styles from './styles';

const useStyles = createUseStyles(styles, 'MatchFields');

const MatchFields = ({
    matchBy,
    listProps,
    currentState,
    onConfirm,
    modalConfirmProps,
    matchingModalRef,
    setMatchingModalRef,
    setWidth,
    matchFieldsCreateModalProps,
    entityName,
    data,
}) => {
    const classes = useStyles();

    useEffect(() => {
        const updateWidth = () => {
            setWidth(document.body.scrollWidth);
        };
        setTimeout(updateWidth, 500);
        window.addEventListener('resize', updateWidth);
        return () => {
            window.removeEventListener('resize', updateWidth);
            setMatchingModalRef(null);
        };
    }, [setWidth, setMatchingModalRef]);

    const finalListProps = useMemo(() => {
        return { ...listProps, className: classes.matchFieldsList };
    }, [listProps, classes]);

    return (
        <Fragment>
            {currentState >= 2 && <SectionList {...finalListProps} />}
            <MatchingModal
                onRef={(ref) => !matchingModalRef && setMatchingModalRef(ref)}
                onConfirm={onConfirm}
                matchBy={matchBy}
            />
            <ModalConfirm {...modalConfirmProps} />
            <CreateFieldModal
                entityName={entityName}
                data={data}
                {...matchFieldsCreateModalProps}
            />
        </Fragment>
    );
};

MatchFields.propTypes = {};

export default memo(MatchFields);
